import {
  Button,
  type ButtonProps,
  Link as MuiLink,
  styled,
  useTheme,
} from "@mui/material"
import { ChevronRight } from "react-feather"

const CHEVRON_CLASSNAME = "chevron"

export const LoyaltyProgramButton = ({
  href,
  label,
  slotProps = {},
}: {
  href: string
  label: string
  slotProps?: {
    Button?: ButtonProps<typeof MuiLink>
  }
}) => {
  const theme = useTheme()
  return (
    <ButtonStyled
      component={MuiLink}
      variant="text"
      href={href}
      endIcon={
        <ChevronStyled
          className={CHEVRON_CLASSNAME}
          size={theme.typography.pxToRem(15)}
        />
      }
      {...slotProps?.Button}
    >
      {label}
    </ButtonStyled>
  )
}

const ButtonStyled = styled(Button)({
  "&:hover": {
    [`.${CHEVRON_CLASSNAME}`]: {
      transform: "translateX(3px)",
    },
  },
}) as typeof Button

const ChevronStyled = styled(ChevronRight)({
  transition: "transform ease-in-out 150ms",
})
